(() => {
  const explorer = document.querySelector('[data-fabric-explorer]')
  if (!explorer) return
  const activeFilters = { type: 'all', colour: 'all' }
  const cards = [...explorer.querySelectorAll('[data-fabric-card]')]
  const groups = [...explorer.querySelectorAll('[data-fabric-group]')]
  const total = explorer.querySelector('[data-fabric-total]')
  const empty = explorer.querySelector('[data-fabric-empty]')
  const modal = explorer.querySelector('[data-fabric-explorer-modal]')
  const modalBody = explorer.querySelector('[data-fabric-modal-body]')
  const sampleForms = [...explorer.querySelectorAll('[data-fabric-sample-form]')]

  const setSampleAdded = (form, added) => {
    const button = form?.querySelector('button[type="submit"]')
    const card = form?.closest('[data-fabric-card]')
    if (!button || !card) return
    button.classList.toggle('is-added', added)
    card.classList.toggle('is-added', added)
    button.setAttribute('aria-label', added ? 'Sample added' : 'Add sample')
    const icon = button.querySelector('span[aria-hidden="true"]')
    if (icon) icon.textContent = added ? '✓' : '+'
  }

  document.addEventListener('variant:add', (event) => {
    const form = event.detail?.formElement
    if (form?.closest('[data-fabric-explorer]') === explorer) setSampleAdded(form, true)
  })

  document.addEventListener('cart:change', (event) => {
    const cart = event.detail?.cart
    if (!cart?.items) return
    explorer.querySelectorAll('.fabric-explorer__sample-form').forEach((form) => {
      const variantId = String(form.querySelector('[name="id"]')?.value || '')
      const added = cart.items.some((item) => String(item.variant_id) === variantId && item.properties?._fabric_sample === 'true')
      setSampleAdded(form, added)
    })
  })

  const syncCartCount = (cart) => {
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]').forEach((node) => {
      node.textContent = String(cart.item_count || 0)
    })
  }

  const syncSampleState = (cart) => {
    sampleForms.forEach((form) => {
      const variantId = String(form.querySelector('[name="id"]')?.value || '')
      const added = cart.items?.some((item) => String(item.variant_id) === variantId && item.properties?._fabric_sample === 'true')
      setSampleAdded(form, Boolean(added))
    })
  }

  const getCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json())

  sampleForms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault()
      const button = form.querySelector('button[type="submit"]')
      if (!button || button.getAttribute('aria-disabled') === 'true') return
      button.setAttribute('aria-disabled', 'true')
      button.classList.add('loading')
      form.querySelector('.fabric-explorer__add-spinner')?.classList.remove('hidden')
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form),
        })
        const result = await response.json()
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this sample')
        const cart = await getCart()
        syncSampleState(cart)
        syncCartCount(cart)
        document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart, source: 'fabric-samples-explorer' } }))
      } catch (error) {
        console.error('Fabric sample add failed:', error)
      } finally {
        button.classList.remove('loading')
        button.removeAttribute('aria-disabled')
        form.querySelector('.fabric-explorer__add-spinner')?.classList.add('hidden')
      }
    })
  })

  const updateResults = () => {
    let visible = 0
    cards.forEach((card) => {
      const matchesType = activeFilters.type === 'all' || card.dataset.fabricType === activeFilters.type
      const matchesColour = activeFilters.colour === 'all' || card.dataset.fabricColour === activeFilters.colour
      const show = matchesType && matchesColour
      card.hidden = !show
      if (show) visible += 1
    })
    groups.forEach((group) => { group.hidden = ![...group.querySelectorAll('[data-fabric-card]')].some((card) => !card.hidden) })
    total.textContent = String(visible)
    empty.hidden = visible !== 0
  }

  explorer.querySelectorAll('[data-fabric-filter-group]').forEach((group) => {
    group.addEventListener('click', (event) => {
      const button = event.target.closest('[data-fabric-filter]')
      if (!button) return
      activeFilters[group.dataset.fabricFilterGroup] = button.dataset.fabricFilter
      group.querySelectorAll('[data-fabric-filter]').forEach((item) => item.classList.toggle('is-active', item === button))
      updateResults()
    })
  })

  const openModal = (source) => {
    const card = source.closest('[data-fabric-card]') || source.closest('[data-fabric-group]')?.querySelector('[data-fabric-card]')
    const template = card?.querySelector('[data-fabric-detail-template]')
    if (!template) return
    modalBody.replaceChildren(template.content.cloneNode(true))
    modal.classList.add('is-open')
    modal.setAttribute('aria-hidden', 'false')
    document.body.classList.add('fabric-explorer-modal-open')
    modal.querySelector('[data-fabric-modal-close]')?.focus()
  }
  const closeModal = () => { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.classList.remove('fabric-explorer-modal-open') }
  explorer.addEventListener('click', (event) => {
    const detail = event.target.closest('[data-fabric-detail-open],[data-fabric-family-open]')
    if (detail) { openModal(detail); return }
    if (event.target.closest('[data-fabric-modal-close]')) { closeModal(); return }
    const tab = event.target.closest('[data-fabric-modal-tab]')
    if (tab) {
      const target = tab.dataset.fabricModalTab
      modal.querySelectorAll('[data-fabric-modal-tab]').forEach((item) => item.classList.toggle('is-active', item === tab))
      modal.querySelectorAll('[data-fabric-modal-panel]').forEach((item) => { item.hidden = item.dataset.fabricModalPanel !== target })
    }
  })
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal() })
  updateResults()
  getCart().then((cart) => { syncSampleState(cart); syncCartCount(cart) }).catch(() => {})
})()
